import React from 'react';
import { motion } from 'framer-motion';

const Gatekeeper = () => (
  <section className="relative py-28 overflow-hidden border-y border-wine/20">
    <div className="absolute inset-0 bg-dark" />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(114,47,55,0.12)_0%,transparent_65%)]" />
    <div
      className="absolute top-0 left-0 right-0 h-[1px]"
      style={{ background: 'linear-gradient(to right, transparent, rgba(114,47,55,0.6), transparent)' }}
    />

    <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
      <motion.p
        initial={{ opacity: 0, letterSpacing: '0.1em' }}
        whileInView={{ opacity: 1, letterSpacing: '0.35em' }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className="text-wine-light uppercase text-xs mb-10 font-semibold tracking-[0.3em]"
      >
        Bevor du dich anmeldest
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="text-4xl md:text-5xl font-serif text-cream mb-10 leading-tight"
      >
        Dies ist keine{' '}
        <span className="italic text-wine-light" style={{ textShadow: '0 0 20px rgba(155,66,78,0.4)' }}>
          gewöhnliche Masterclass.
        </span>
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="space-y-6 text-lg text-cream/70 font-light leading-relaxed"
      >
        <p>
          Melde dich nur an, wenn du wirklich bereit bist zu investieren – deine Zeit, deine Präsenz
          und deine Bereitschaft, dich ehrlich anzuschauen.
        </p>
        <p>
          Dieser Raum ist reserviert für Frauen, die es satt haben, halbherzig vorzugehen. Frauen,
          die <em className="text-cream font-serif">echte</em> Veränderung wollen – nicht einen
          inspirierenden Abend, den sie am nächsten Morgen vergessen haben.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, delay: 0.6 }}
        className="w-full h-[1px] mt-16 origin-center"
        style={{ background: 'linear-gradient(to right, transparent, rgba(114,47,55,0.5), transparent)' }}
      />

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.9 }}
        className="text-xs text-cream/30 mt-8 tracking-widest uppercase"
      >
        Wenn das resoniert — dann bist du genau richtig hier.
      </motion.p>
    </div>
  </section>
);

export default Gatekeeper;